export class LoginState {
    UserName?: string;
    AccessLevel?: number;
    UserId?: number
}

export class Player {
    id!: number;
    name?: string;
    province?: string;
    country?: string;
    email!: string;
    tableTennis!: number;
    badminton!: number;
    squash!: number;
    tennis!: number;
    singlesPoints!: number;
    doublesPoints!: number;
    gender?: string
    password?: string
    phone?: string
    accessLevel!: number;
    gradingReviewed?: Boolean
    DOB?: Date
    singlesRankingChange?: number;
    doublesRankingChange?: number;
    singlesMatchesPlayed!: number;
    doublesMatchesPlayed!: number;
    hasPlayedSingles?: boolean;
    hasPlayedDoubles?: boolean;
    hasPlayedSinglesInLastYear?: boolean;
    hasPlayedDoublesInLastYear?: boolean;
    hasPlayedSinglesInLast2Years?: boolean;
    hasPlayedDoublesInLast2Years?: boolean;
    hasPlayedInLastYear = false;
    SinglesMatchesPlayed = 0;
    DoublesMatchesPlayed = 0;
    TotalPointsWonTT = 0
    TotalPointsWonBad = 0
    TotalPointsWonSq = 0
    TotalPointsWonT = 0
    TotalPointsLostTT = 0
    TotalPointsLostBad = 0
    TotalPointsLostSq = 0
    TotalPointsLostT = 0
    BadRating?: number;
    SqRating?: number;
    TTRating?: number;
    TRating?: number;
    Partner!: Player;
    DoublesTotalPoints!: number;
    Team?: number;
    SinglesGrade?: string;
    DoublesGrade?: string;
    badRating = 0;
    tRating = 0;
    sqRating = 0;
    ttRating = 0;
}

export class Match {
    id?: number;
    matchNo?: number;
    player1!: number;
    player2!: number;
    player3!: number; 
    player4!: number;
    ttScore1!: number;
    badScore1!: number;
    squashScore1!: number;
    tScore1!: number;
    ttScore2!: number;
    badScore2!: number;
    squashScore2!: number;
    tScore2!: number;
    dateOfMatch!: Date;
    duration?: number;
    torn?: number;
    draw?: number;
    player1Name?: string
    player2Name?: string
    processed?: Boolean
    startPoints1?: number;
    startPoints2?: number;
    startPoints3?: number;
    startPoints4?: number;
    newPoints1?: number;
    newPoints2?: number;
    newPoints3?: number;
    newPoints4?: number;
    notPlayed?: Boolean
    subDrawNumber?: number;
    woWinner?: number;
    doNotProcess?: Boolean
    noTennis?: Boolean
    singles?: boolean;
    doubles?: boolean;
    doublesPlayer1?: String;
    doublesPlayer2?: String;
    doublesPlayer3?: String;
    doublesPlayer4?: String;
    player1Change?: number;
    player2Change?: number;
    player3Change?: number;
    player4Change?: number;
    tornName?: String;
    score1!: string;
    score2!: string;
    Winner!: Player;
    Score?: String;
    formatedDateOfMatch?: string;
    Loser!: Player;
    MatchScore!: string;
}

export class Tornament {

    id!: number;
    name?: String
    dateOfEvent!: Date;
    eventDateString?: string;
    endDateOfEvent?: Date;
    eventEndDateString?: string;
    closingDate!: Date
    entryClosedDateString?: string;
    directorId?: number;
    venueInfo?: String
    eventInfo?: String
    accomodationInfo?: String
    feeInfo?: String
    scheduleInfo?: String
    prizeGivingInfo?: String
    extraInfo?: String
    sponsorImage?: String
    sponsorURL?: String
    liveStreamURL?: String
    posterLocation?: String
    presetInfoSheet?: string
    doubles?: String
    courts?: number;
    lastUpdate?: Date;
    account?: String
    accountName?: String
    entries!: Entry[];
    draws!: Draw[];
    events!: AnEvent[];
    discount!: number;
    Director?: Player;
    AllowRepeat?: Boolean;
    Days2AfterStart?: Date;
    Days2FromEndDate?: Date;
    isTeams?: Boolean;
    SinglesPlayers!: Player[];
    DoublesPlayers!: Player[];
    MatchDuration!: number;
    UserEntered?: Boolean;
    Teams!: Team[];
    Message?: String;
    EntryCount?: number;
}

export class Draw {
    id!: number;
    name?: String
    Name?: String
    tornament?: number;
    Matches!: Match[];
    Players1!: Player[];
    Players2!: Player[];
    format?: String
    type?: String
    gender?: String
    numberOfRRs!: number;
    theEventID!: number;
    theEvent!: AnEvent;
    KO4Player?: Boolean;
    AvailablePlayers!: Player[];
    Places1!: any[];
    Places2!: any[];
    Winner?: string;
    RunnerUp?: string;
}

export class Entry {
    id?: number;
    dateOfEntry?: Date
    name?: String
    email?: String
    phone?: String
    province?: String
    country?: String
    gender?: String
    ttGrade?: number
    badGrade?: number
    sqGrade?: number
    tennisGrade?: number
    singles?: Boolean
    doublesMixed?: Boolean
    comments?: String
    partnerReq?: Boolean
    tornament?: number;
    //TornamentObject: Tornament
    playerId?: number;
    eventsList!: AnEvent[];
    events?: String;
    feesPaid?: Boolean
    fee?: number;;
    SendAnnouncement?: Boolean
    team?: number;
    singlesPoints?: number;
    doublesPoints?: number;
    YearsOld?: number;
}

export class Result {
    Result?: Object
    ExceptionName?: String
    TaskAtHand?: String
    Message?: String
    ExtraDetails?: String
}

export class UserTrace {
    IPv4?: String;
    city?: String;
    country_code?: String;
    country_name?: String;
    latitude?: number;
    longitude?: number;
    postal?: String;
    state?: number;
}

export class Log {
    id?: number;
    DateOfEvent?: String
    EventType?: String
    Details?: String
    TornId?: number;
    City?: String
    IP?: String
    Country?: String
}

export class ErrorLog {
    DateOfError?: String
    Location?: String
    StackTrace?: String
    Message?: String
}

export class Setting {
    setting?: String
    value?: String
}

export class Adjustment {
    DateOfAdjustment?: String
    PlayerID?: number;
    Adjustment?: number;
    Reason?: String
    Type?: String
}

export class AnEvent {
    id?: number;
    tornId?: number;
    name?: String
    type?: String
    minAge?: number;
    maxAge?: number;
    cost?: number;
    teams?: Boolean;
    Players!: Player[];
    PartnerId!: number;
    Partner!: Player;
    updateNeeded?: Boolean;
    Total?: number;
    Good?: Boolean;
    DoublesTotalPoints?: number;
    
}

export class Team {
    id?: number;
    Torn?: number;
    Name?: String
    _Event?: number;
    Points?: number;
    Colour?: String
}